// extracted by mini-css-extract-plugin
module.exports = {"accounts":"AccountsPage_accounts__2L_zm","merchant":"AccountsPage_merchant__2oaKr","user":"AccountsPage_user__lL_6v"};